import Notification from './Notification'
import TextImage from './TextImage'
import ImageText from './ImageText'
import Symptoms from './Symptoms'
import Testimonials from './Testimonials'
import Cards from './Cards'

const Content = ({ notification, sectionImageText, sectionReason, sectionTestimonials, sectionTextImage, ctaButton, symptoms }) => {
  return (
    <>
      <Notification content={notification} />
      <TextImage {...sectionTextImage} ctaButton={ctaButton} />
      <Cards {...sectionReason} />
      <Symptoms content={symptoms} />
      <Testimonials {...sectionTestimonials} ctaButton={ctaButton} />
      <ImageText {...sectionImageText} />
    </>
  )
}

export default Content
